import Switch, { SwitchProps } from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import React from 'react';
import './SettingsSwitch.scss';
import { FormControlLabel } from '@mui/material';
import { CoinForecasterService } from '../services/CoinForecasterService';


type Props  = {
    settingId: string;
    settingTitle: string;
    on: boolean;
};

export default function SettingsSwitch(props: Props): JSX.Element {

  return (
    <div className='settings-switch-container d-flex justify-content-between'>
        <span>{props.settingTitle}</span>
        <FormControlLabel
            onChange={(e,checked)=>{
                if (checked) {
                    localStorage.setItem(props.settingId, "true");
                    CoinForecasterService.sendSetting({id:props.settingId,value:true});
                } else {
                    localStorage.setItem(props.settingId, "false");
                    CoinForecasterService.sendSetting({id:props.settingId,value:false});
                }
            }}
            style={{margin:0}}
            control={<IOSSwitch sx={{ m: 1 }} defaultChecked={props.on} />}
            label={""}
        />
    </div>
  );
}

const IOSSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: theme.palette.mode === 'dark' ? '#3476E4' : '#3476E4',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color:
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }));